import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../../utils/constants';

import {
    fetchTemplateTest,
    fetchQuestionsTemplateTest,
} from '../../utils/common-functions';

function* asyncFetchTemplateTest({ payload: { testId } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const response = yield call(fetchTemplateTest, { testId });
        const responseQuestions = yield call(fetchQuestionsTemplateTest, {
            testId,
        });

        yield put({
            type: actions.CHANGE_TEMPLATE_TESTS_TO_DUPLICATE,
            payload: response.data,
        });

        yield put({
            type: actions.CHANGE_QUESTIONS_TEMPLATE_TESTS_TO_DUPLICATE,
            payload: responseQuestions.data.template_questions,
        });

        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: err.response.data.error_description,
            },
        });
    }
}

export default function* duplicateTemplateTest() {
    yield takeEvery(
        actions.ASYNC_FETCH_TEMPLATE_TESTS_TO_DUPLICATE,
        asyncFetchTemplateTest,
    );
}



// WEBPACK FOOTER //
// ./src/components/duplicate-template-test/duplicate-template-test.saga.js